import axios from 'axios'

const API_URL = process.env.VUE_APP_GOLD_MEMBER

export function getOptionsListAsync(premium = 'gold') {
  return axios.get(API_URL + '/api/v1.0/customer/options' + '?premium=' + premium)
}

export function addGoldMemberOrder(params) {
  return axios.post(API_URL + '/api/v1.0/customer/0A/order', params)
}

export function addPaymentToOrder(orderId, params) {
  return axios.post(API_URL + '/api/v1.0/0A/order/' + orderId + '/pay', params)
}
